/**
 * Client-side mirror of backend pkg/restorepath (QA #81, PM/QA decision
 * 2026-09-21): the restore-directory field says what is wrong as the person
 * types; the backend refuses the same input with the same wording, so the
 * two never disagree.
 *
 * `/` and `\` are path separators and `.` is an ordinary name character
 * (/tmp/restore.v2), so they are allowed on purpose.
 */

/** The hint under the input and the reason on the field, verbatim from the QA decision. */
export const RESTORE_PATH_RULE_TEXT = '還原路徑不可包含 < > : " | ? *';

const FORBIDDEN = /[<>:"|?*]/;

function hasControlCharacter(path: string): boolean {
  for (const ch of path) {
    const code = ch.codePointAt(0) ?? 0;
    if (code < 0x20 || code === 0x7f) return true;
  }
  return false;
}

/**
 * Returns the problem with a restore path, or '' when it passes. With
 * `required` false an empty value passes, for live checks while the person
 * is still typing (emptiness is only refused on submit).
 */
export function restorePathProblem(path: string, required = true): string {
  if (!path.trim()) return required ? '請輸入還原目錄的完整路徑（例如 /tmp/restore）' : '';
  if (FORBIDDEN.test(path)) return RESTORE_PATH_RULE_TEXT;
  if (hasControlCharacter(path)) return '還原路徑不可包含換行、Tab 等控制字元';
  return '';
}
